var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"feature-head"},[_c('el-divider',[_c('h1',[_vm._v(_vm._s(_vm.text))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }